import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';

function ParkingPrintOptions() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isUpdate = location.state?.isUpdate || false;

    const handlePrintTicket = () => {
        window.open(`/accounts/parking-customer-ticket/${id}`);
    };

    const handlePrintImageTicket = () => {
        window.open(`/accounts/parking-car-ticket/${id}`, '_blank');
    };

    const handlePrintKeyTicket = () => {
        window.open(`/accounts/parking-key-ticket/${id}`, '_blank');
    };

    const handlePrintQRCode = () => {
        window.open(`/accounts/parking-qr-code/${id}`, '_blank');
    };

    const handlePrintCombinedTicket = () => {
        window.open(`/accounts/parking-combined-ticket/${id}`, '_blank');
    };

    const printKeyAndCarTickets = () => {
        navigate(`/accounts/parking-valet-ticket/${id}`);
    };

    const handleBackToList = () => {
        navigate('/accounts/parking-list');
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle="Welcome to Your Parking Ticket Page" />
                <Card>
                    <Card.Body className="text-center">
                        {/* <div className="mb-4">
                            <div className="mb-3">
                                <i className="fa fa-check-circle text-success" style={{ fontSize: '48px' }}></i>
                            </div>
                            <h4 className="text-success mb-3">
                                Thank You for Choosing Our Service!
                            </h4>
                            <p className="text-muted">
                                Your parking reservation is confirmed. Please choose your ticket type to print below.
                            </p>
                        </div> */}

                        <Row className="justify-content-center">
                            <Col md={8}>
                                <div className="d-grid gap-3">
                                    <Button 
                                        variant="primary" 
                                        size="lg"
                                        onClick={handlePrintTicket}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-print me-2"></i>
                                        Print Customer Ticket
                                    </Button>

                                    <Button 
                                        variant="primary" 
                                        size="lg"
                                        onClick={printKeyAndCarTickets}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-print me-2"></i>
                                        Print Valet Ticket
                                    </Button>
                                    
                                    {/* <Button 
                                        variant="info" 
                                        size="lg"
                                        onClick={handlePrintImageTicket}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-image me-2"></i>
                                        Car Ticket
                                    </Button>

                                    <Button 
                                        variant="success" 
                                        size="lg"
                                        onClick={handlePrintKeyTicket}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-key me-2"></i>
                                        Key Ticket
                                    </Button>

                                    <Button 
                                        variant="warning" 
                                        size="lg"
                                        onClick={handlePrintQRCode}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-qrcode me-2"></i>
                                        QR Code Only
                                    </Button> */}

                                    {/* <Button 
                                        variant="dark" 
                                        size="lg"
                                        onClick={handlePrintCombinedTicket}
                                        className="d-flex align-items-center justify-content-center"
                                    >
                                        <i className="fa fa-print me-2"></i>
                                        Combined Single Ticket
                                    </Button> */}
                                    
                                    <div className="mt-3">
                                        <Button 
                                            variant="outline-secondary"
                                            onClick={handleBackToList}
                                            className="d-flex align-items-center justify-content-center"
                                        >
                                            <i className="fa fa-arrow-left me-2"></i>
                                            Back to Parking List
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="mt-4 pt-3 border-top">
                            <small className="text-muted">
                                Ticket ID: #{id}
                            </small>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ParkingPrintOptions;
